<div class="wrapper flex flex-col gap-[40px]">
  @if (options.showHeading !== false) {
    <div class="heading text-type-2">{{ translations?.ReportNotes?.plurals?.one || 'Note' }}</div>
  }
  <app-text-input
    [parentFormGroup]="form"
    controlName="note_type"
    label="Notes type"
    />
  <app-text-area
    [parentFormGroup]="form"
    controlName="description"
    label="Description"
    />
  @if (data?.source_entity_extra_attributes) {
    <div class="metadata-row flex gap-[40px]">
      <app-view-field
        class="flex-1"
        label="Created by"
        [value]="data?.source_entity_extra_attributes?.source_created_by || '-'"
        />
      <app-view-field
        class="flex-1"
        label="Created at"
        [value]="formatDate(data?.source_entity_extra_attributes?.source_created_at)"
        />
    </div>
    <div class="metadata-row flex gap-[40px]">
      <app-view-field
        class="flex-1"
        label="Updated by"
        [value]="data?.source_entity_extra_attributes?.source_updated_by || '-'"
        />
      <app-view-field
        class="flex-1"
        label="Updated at"
        [value]="formatDate(data?.source_entity_extra_attributes?.source_updated_at)"
        />
    </div>
  }
  @if (options.showActionsSection === undefined || options.showActionsSection) {
    <app-actions-section
      [disableOptionMenu]="disableOptionMenu"
      [hideAddMenu]="true"
      class="actions-section w-[455px]"
      />
  }
</div>
